export default __webpack_public_path__ + "static/media/DUSTY_3.25271d24.gif";